<template>
  <div class="container" :style="`width: ${itemWidth}px;`">
    <div class="logo">
      <img src="../../../assets/suhai.png" alt="" />
    </div>
    <div class="nome">{{ option.nomeCobertura }}</div>
    <div class="total">
      De <s>{{ option.valorSeguroSemDesconto }}</s> <br>
      Por <span class="valor-seguro" :style="{ color: chatbotColors.sentMessage.bg }">{{ option.valorSeguro }}</span>
      <span class="a-vista" :style="{ color: chatbotColors.sentMessage.bg }">/ à vista</span>
    </div>
    <table>
      <tr :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: 'white' }">
        <td></td>
        <td style="text-align: right;">Parcela</td>
        <td style="text-align: right;">Total</td>
        <td style="text-align: center;">Juros</td>
      </tr>
      <tr v-for="parcela in option.parcelas" :key="`parcela-${parcela.quantidade}`">
        <td style="white-space: nowrap; text-align: center;">{{ parcela.quantidade }}x</td>
        <td style="white-space: nowrap; text-align: right;">{{ parcela.valorParcela }}</td>
        <td style="white-space: nowrap; text-align: right;">{{ parcela.valorTotal }}</td>
        <td style="white-space: nowrap; text-align: center;">{{ parcela.comJuros ? 'Sim' : 'Não' }}</td>
      </tr>
    </table>
    <div class="options">
      <button type="button" class="botao" :disabled="optionSelected" @click.prevent="$emit('selectOption', option)">CONTRATAR AGORA</button>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    chatbotColors: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      required: true
    },
    itemWidth: {
      type: Number,
      required: true
    },
    optionSelected: {
      type: Object
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 10px;
  padding: 15px;
  background: white;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 4px 12px;
}
.logo {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 130px;
    max-height: 90px;
  }
}
.nome {
  font-size: .9rem;
  text-align: center;
  color: #275145;
}
.total {
  margin-top: 15px;
  text-align: center;
  padding: 5px;
  border-radius: 10px;
  background: #f0faf9;
  color: #aaa;
  font-size: 0.8rem;

  s {
    font-weight: 500;
    color: #275145;
  }

  span.valor-seguro {
    font-size: 1.2rem;
    font-weight: 500;
    letter-spacing: -1px;
  }

  span.a-vista {
    font-size: 0.8rem;
  }
}
.options {
  display: flex;
  justify-content: center;
  margin-top: 10px;

  .botao {
    display: inline-block;
    padding: 8px 15px;
    border: 0;
    border-radius: 20px;
    font-size: 0.8rem;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    background: #275145;
    color: white;

    &:hover {
      opacity: .8;
    }

    &:disabled {
      opacity: .3;
      cursor: not-allowed;
      pointer-events: all !important;
    }
  }
}
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.7rem;
}
tr:nth-of-type(odd) {
  background-color: #eee;
}
td {
  border: 0;
  padding: .1rem;
  vertical-align: top;
}
</style>
